export default {
  baseUri: process.env.REACT_APP_BASE_URL || 'https://api-sales.stage.sputnik.systems/api/v1',
  redirectUri: process.env.REACT_APP_REDIRECT_URL || 'https://api-sales.stage.sputnik.systems',
  ssoUri: process.env.REACT_APP_SSO_URL || 'https://sso.sputnik.systems',
  partnerUri: 'https://api-partner.sputnik.systems' || 'https://api-partner.stage.sputnik.systems',
  app: 'Продажи',
  brand: 'Спутник',
}
